import React from "react";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
  IconButton,
  Tooltip,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { coldarkCold } from "react-syntax-highlighter/dist/esm/styles/prism";

// Group responses by statusCode
const groupByStatusCode = (responses) => {
  const grouped = {};
  responses.forEach((res) => {
    if (!grouped[res.statusCode]) grouped[res.statusCode] = [];
    grouped[res.statusCode].push(res);
  });
  return grouped;
};

function Responses({ selectedEndpoint = [] }) {
  const grouped = groupByStatusCode(selectedEndpoint);
  const statusCodes = Object.keys(grouped);
  const [tab, setTab] = React.useState(0);
  const [selectedNames, setSelectedNames] = React.useState(() =>
    statusCodes.reduce((acc, code) => {
      acc[code] = grouped[code][0]?.name || "";
      return acc;
    }, {})
  );

  const handleCopy = (code) => {
    navigator.clipboard.writeText(code);
  };

  const handleSelectChange = (code, name) => {
    setSelectedNames((prev) => ({ ...prev, [code]: name }));
  };

  const currentCode = statusCodes[tab];
  const currentResponses = grouped[currentCode];
  const selectedResponse = currentResponses.find(
    (r) => r.name === selectedNames[currentCode]
  );

  return (<>
    <Tabs
      value={tab}
      onChange={(e, val) => setTab(val)}
      variant="scrollable"
      scrollButtons="auto"
    >
      {statusCodes.map((code, idx) => (
        <Tab key={code} label={code} sx={{ textTransform: "none" }} />
      ))}
    </Tabs>
    <Paper elevation={0} sx={{ background: "#ECF2FE", p: "16px", borderRadius: 2 }}>

      <Box sx={{ position: "relative" }}>
        {currentResponses.length > 1 && (
          <FormControl size="small" >
            <Select
              value={selectedNames[currentCode]}
              onChange={(e) => handleSelectChange(currentCode, e.target.value)}
            >
              {currentResponses.map((res) => (
                <MenuItem key={res.name} value={res.name}>
                  {res.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <Tooltip title="Copy">
          <IconButton
            onClick={() => handleCopy(selectedResponse?.payload)}
            sx={{ position: "absolute", right: 0, top: 0, display: "flex", alignItems: "center", gap: "3px" }}
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_108_1337)">
              <path d="M6 10C6 8.11438 6 7.17157 6.58579 6.58579C7.17157 6 8.11438 6 10 6L10.6667 6C12.5523 6 13.4951 6 14.0809 6.58579C14.6667 7.17157 14.6667 8.11438 14.6667 10V10.6667C14.6667 12.5523 14.6667 13.4951 14.0809 14.0809C13.4951 14.6667 12.5523 14.6667 10.6667 14.6667H10C8.11438 14.6667 7.17157 14.6667 6.58579 14.0809C6 13.4951 6 12.5523 6 10.6667L6 10Z" stroke="#686868" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M11.3332 6.00001C11.3316 4.02862 11.3018 3.00748 10.7279 2.3083C10.6171 2.17327 10.4933 2.04946 10.3583 1.93865C9.62074 1.33334 8.52491 1.33334 6.33325 1.33334C4.1416 1.33334 3.04577 1.33334 2.3082 1.93865C2.17318 2.04946 2.04937 2.17327 1.93856 2.30829C1.33325 3.04586 1.33325 4.14169 1.33325 6.33334C1.33325 8.525 1.33325 9.62082 1.93856 10.3584C2.04937 10.4934 2.17318 10.6172 2.3082 10.728C3.00739 11.3018 4.02852 11.3317 5.99992 11.3333" stroke="#686868" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
              <clipPath id="clip0_108_1337">
              <rect width="16" height="16" fill="white"/>
              </clipPath>
              </defs>
            </svg>
            <Typography
                sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "#686868",}}>Copy
            </Typography>
          </IconButton>
        </Tooltip>

        {selectedResponse?.description && (
          <Typography variant="caption" sx={{ mt: 1, display: "block", color: "#666", fontSize: '14px' }}>
            {selectedResponse.description}
          </Typography>
        )}
        <SyntaxHighlighter
          language="json"
          style={coldarkCold}
          wrapLongLines
          customStyle={{
            padding: "16px",
            borderRadius: "10px",
            fontSize: "14px",
            background: "#FFFFFF",
            margin: 0,
          }}
        >
          {JSON.stringify(JSON.parse(selectedResponse?.payload || ""), null, 2)}
        </SyntaxHighlighter>
      </Box>
    </Paper>
    </>
  );
}

export default Responses;
